import { Locale } from "date-fns";
import { ptBR, enUS, es } from "date-fns/locale";
import i18n from "i18next";

export const getLocale = (language?: string): Locale => {
  const locale = language || i18n.language;
  if(locale.includes("es")) 
    return es;
  if(locale.includes("en"))
    return enUS;
  return ptBR;
};
